import React, {useState} from "react";
import { Route, Routes } from "react-router-dom";
import AddMember from "../pages/AddMember/AddMember";
// import Attendance from "../pages/Attendance/Attendance";
import Dashboard from "../pages/Dashboard/Dashboard";
import Sidebar from "../components/sidebar/Sidebar";
import Topbar from "../components/topbar/Topbar";
import { useGlobalContext } from "../context/stateContext";
import NotFound from "../pages/NotFound";
import Finance from "../pages/Finance/Finance";
import MemberManagement from "../pages/Membermanagement/MemberManagement";
import MemberProfile from "../pages/MemberProfile/MemberProfile";
// import Settings from "../pages/Settings/Settings";
import UserManagement from "../pages/Usermanagement/UserManagement";
import SuperadminRoutes from "./SuperadminRoutes";
import Settings from "../pages/Settings/Settings";
import IncomeList from "../pages/Finance/IncomeList";
import ExpenseList from "../pages/Finance/ExpenseList";
import ProfitLossStatement from "../pages/Finance/ProfitLossStatement";
import VisitorsList from "../pages/Membermanagement/VisitorsList";
import AddVisitor from "../pages/AddMember/AddVisitor";
import VisitorDetail from "../pages/Membermanagement/VisitorDetail";
import Cells from "../pages/CellManagement/Cells";
import NewGroup from "../pages/CellManagement/NewGroup";
import GroupDetails from "../pages/CellManagement/GroupDetails";
import GroupsRoute from "../routes/groups/GroupsRoute";
import GroupSelection from "../pages/Login/GroupSelection";
import UsherDashboard from "../pages/Dashboard/UsherDashboard";
import ChurchAttendance from "../pages/ChurchAttendance/ChurchAttendance";
import AttendanceReport from "../pages/ChurchAttendance/AttendanceReport";
// import WebsiteResource from "../pages/WebsiteResource/WebsiteResource";
// import AddVisitor from "../pages/AddMember/AddVisitor";

const Layout = () => {
  const { isSidebarOpen,setIsSidebarOpen} = useGlobalContext();
  return (
    <div className={`flex justify-center items-start overflow-x-clip ${isSidebarOpen ? "pl-[300px]" : "pl-0"}`}>
      <Sidebar />
      <main className="w-full mx-auto relative">
        <Topbar />
        <div className="px-10 py-20">
          <Routes>
            <Route path="/group-selection" element={<GroupSelection />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/members" element={<MemberManagement />} />
            <Route path="/members/new" element={<AddMember />} />
            <Route path="/members/:member_id/profile" element={<MemberProfile />} />
            <Route path="/visitors" element={<VisitorsList />} />
            <Route path="/finance/overview" element={<Finance />} />
            <Route path="/finance/income" element={ <IncomeList />} />
            <Route path="/finance/expenses" element={<ExpenseList />} />
            <Route path="/finance/income-statement" element={<ProfitLossStatement />} />
            <Route path="/add-visitor" element={<AddVisitor />} />
            <Route path="/visitors/:visitor_id/details" element={<VisitorDetail />} />
            <Route path="/group-management" element={<Cells />} />
            <Route path="/group-management/new" element={<NewGroup />} />
            <Route path="/group-management/:groupId" element={<GroupDetails />} />
            <Route path="/church-attendance" element={<ChurchAttendance />} />
            <Route path="/church-attendance/report" element={<AttendanceReport />} />
            
            <Route path="/settings" element={<Settings />} />
            <Route path="/super/*" element={<SuperadminRoutes />} />
            <Route path="/groups/*" element={<GroupsRoute />} />
            <Route path="/usher/dashboard" element={<UsherDashboard />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default Layout;
